import { useCallback, useEffect, useState } from 'react';
import {
  readOnboardingState,
  patchOnboardingState,
  subscribeOnboardingState,
} from '../utils/investorOnboardingPersistence';

/**
 * React hook for investor onboarding client state with cross-tab sync.
 */
export default function useOnboardingPersistence() {
  const [state, setState] = useState(readOnboardingState);

  useEffect(() => subscribeOnboardingState(setState), []);

  const patch = useCallback((partial) => {
    const next = patchOnboardingState(partial);
    setState(next);
    return next;
  }, []);

  const refresh = useCallback(() => {
    const next = readOnboardingState();
    setState(next);
    return next;
  }, []);

  return { state, patch, refresh };
}
